import React from "react";
import { Container, Form, Button, Card } from "react-bootstrap";
import Logo  from "../assets/images/logo.png";
function Verify() {
  return (
    <div className="login-sign-main common-padding" >
      <Container>
        <Card>
          <div className="login-sign-wrap">
            <img src={Logo} alt="" />
            <h3 className="mb-3">Check Your Email</h3>
            <p className="mt-0">Check the email address test001@gmail.com for<br/> instructions to reset your password.</p>
          </div>

          <Form>
            <Button className="custom-bttn style-3 w-100">
              Resend Email
            </Button>

             <p className="mb-0">
              <a href="/">
                Back to Real Estate
              </a>
            </p>
           
          </Form>
        </Card>
      </Container>
    </div>
  );
}

export default Verify;
